import React, { useState } from 'react';
import { UserIcon, LogInIcon, LogOutIcon, XIcon } from 'lucide-react';
import PageHeader from '../components/PageHeader';
const AccountPage: React.FC = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [isRegistering, setIsRegistering] = useState(false);
  const [viewMode, setViewMode] = useState<'main' | 'devices' | 'subscription' | 'storage'>('main');
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, this would authenticate with a server
    setIsLoggedIn(true);
  };
  const handleRegister = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, this would register the user with a server
    setIsLoggedIn(true);
    setIsRegistering(false);
  };
  const handleLogout = () => {
    setIsLoggedIn(false);
    setViewMode('main');
  };
  const renderLoginForm = () => <div className="bg-gray-900 p-6 rounded-lg" data-id="element-58">
      <h2 className="text-lg font-semibold mb-4" data-id="element-59">Sign In</h2>
      <form onSubmit={handleLogin} data-id="element-60">
        <div className="mb-4" data-id="element-61">
          <label className="block text-gray-400 mb-2" data-id="element-62">Email</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full bg-gray-800 border border-gray-700 p-3 rounded-lg" placeholder="your@email.com" required data-id="element-63" />
        </div>
        <div className="mb-6" data-id="element-64">
          <label className="block text-gray-400 mb-2" data-id="element-65">Password</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full bg-gray-800 border border-gray-700 p-3 rounded-lg" placeholder="••••••••" required data-id="element-66" />
        </div>
        <button type="submit" className="w-full bg-blue-900 text-white py-3 rounded-lg flex items-center justify-center" data-id="element-67">
          <LogInIcon size={20} className="mr-2" data-id="element-68" />
          Sign In
        </button>
      </form>
      <div className="mt-6 text-center" data-id="element-69">
        <p className="text-gray-400" data-id="element-70">Don't have an account?</p>
        <button className="text-[#51a7fa] mt-2" onClick={() => setIsRegistering(true)} data-id="element-71">
          Create Account
        </button>
      </div>
    </div>;
  const renderRegistrationForm = () => <div className="bg-gray-900 p-6 rounded-lg" data-id="element-72">
      <h2 className="text-lg font-semibold mb-4" data-id="element-73">Create Account</h2>
      <form onSubmit={handleRegister} data-id="element-74">
        <div className="mb-4" data-id="element-75">
          <label className="block text-gray-400 mb-2" data-id="element-76">First Name</label>
          <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)} className="w-full bg-gray-800 border border-gray-700 p-3 rounded-lg" placeholder="John" required data-id="element-77" />
        </div>
        <div className="mb-4" data-id="element-78">
          <label className="block text-gray-400 mb-2" data-id="element-79">Email</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full bg-gray-800 border border-gray-700 p-3 rounded-lg" placeholder="your@email.com" required data-id="element-80" />
        </div>
        <div className="mb-6" data-id="element-81">
          <label className="block text-gray-400 mb-2" data-id="element-82">Password</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full bg-gray-800 border border-gray-700 p-3 rounded-lg" placeholder="••••••••" required data-id="element-83" />
        </div>
        <button type="submit" className="w-full bg-blue-900 text-white py-3 rounded-lg flex items-center justify-center" data-id="element-84">
          Create Account
        </button>
      </form>
      <div className="mt-6 text-center" data-id="element-85">
        <p className="text-gray-400" data-id="element-86">Already have an account?</p>
        <button className="text-[#51a7fa] mt-2" onClick={() => setIsRegistering(false)} data-id="element-87">
          Sign In
        </button>
      </div>
    </div>;
  const renderSyncedDevices = () => {
    const devices = [{
      id: 1,
      name: 'iPhone 13',
      lastActive: 'Today, 2:30 PM'
    }, {
      id: 2,
      name: 'iPad Pro',
      lastActive: 'Yesterday, 10:15 AM'
    }, {
      id: 3,
      name: 'MacBook Air',
      lastActive: 'Current device'
    }];
    return <div className="bg-gray-900 p-6 rounded-lg" data-id="element-88">
        <div className="flex items-center justify-between mb-6" data-id="element-89">
          <h2 className="text-lg font-semibold" data-id="element-90">Synced Devices</h2>
          <button onClick={() => setViewMode('main')} className="text-gray-400 hover:text-white" data-id="element-91">
            <XIcon size={20} data-id="element-92" />
          </button>
        </div>
        <button className="w-full bg-red-900 text-white py-2 rounded-lg mb-6" data-id="element-93">
          Disconnect All Devices
        </button>
        <div className="space-y-4" data-id="element-94">
          {devices.map(device => <div key={device.id} className="bg-gray-800 p-4 rounded-lg flex justify-between items-center" data-id="element-95">
              <div data-id="element-96">
                <h3 className="font-medium" data-id="element-97">{device.name}</h3>
                <p className="text-sm text-gray-400" data-id="element-98">{device.lastActive}</p>
              </div>
              {device.lastActive !== 'Current device' && <button className="text-red-500 hover:text-red-400 text-sm" data-id="element-99">
                  Disconnect
                </button>}
            </div>)}
        </div>
      </div>;
  };
  const renderSubscriptionOptions = () => <div className="bg-gray-900 p-6 rounded-lg" data-id="element-100">
      <div className="flex items-center justify-between mb-6" data-id="element-101">
        <h2 className="text-lg font-semibold" data-id="element-102">Subscription</h2>
        <button onClick={() => setViewMode('main')} className="text-gray-400 hover:text-white" data-id="element-103">
          <XIcon size={20} data-id="element-104" />
        </button>
      </div>
      <div className="space-y-6" data-id="element-105">
        <div className="bg-gray-800 p-4 rounded-lg border-2 border-[#51a7fa]" data-id="element-106">
          <div className="flex justify-between items-center mb-2" data-id="element-107">
            <h3 className="text-lg font-medium" data-id="element-108">Free</h3>
            <span className="bg-[#51a7fa] text-black px-2 py-1 rounded text-xs" data-id="element-109">
              CURRENT
            </span>
          </div>
          <ul className="text-sm text-gray-400 space-y-2 mb-4" data-id="element-110">
            <li data-id="element-111">• Basic teleprompter features</li>
            <li data-id="element-112">• Up to 5 saved scripts</li>
            <li data-id="element-113">• 1 synced device</li>
          </ul>
          <p className="text-center font-bold" data-id="element-114">$0 / month</p>
        </div>
        <div className="bg-gray-800 p-4 rounded-lg" data-id="element-115">
          <div className="flex justify-between items-center mb-2" data-id="element-116">
            <h3 className="text-lg font-medium" data-id="element-117">Pro</h3>
            <span className="bg-gray-700 text-gray-300 px-2 py-1 rounded text-xs" data-id="element-118">
              UPGRADE
            </span>
          </div>
          <ul className="text-sm text-gray-400 space-y-2 mb-4" data-id="element-119">
            <li data-id="element-120">• All Free features</li>
            <li data-id="element-121">• Unlimited saved scripts</li>
            <li data-id="element-122">• Up to 5 synced devices</li>
            <li data-id="element-123">• Advanced text formatting</li>
            <li data-id="element-124">• Priority support</li>
          </ul>
          <p className="text-center font-bold" data-id="element-125">$9.99 / month</p>
          <button className="w-full bg-blue-900 text-white py-2 rounded-lg mt-4" data-id="element-126">
            Upgrade to Pro
          </button>
        </div>
      </div>
    </div>;
  const renderStorageDetails = () => <div className="bg-gray-900 p-6 rounded-lg" data-id="element-127">
      <div className="flex items-center justify-between mb-6" data-id="element-128">
        <h2 className="text-lg font-semibold" data-id="element-129">Cloud Storage</h2>
        <button onClick={() => setViewMode('main')} className="text-gray-400 hover:text-white" data-id="element-130">
          <XIcon size={20} data-id="element-131" />
        </button>
      </div>
      <div className="mb-6" data-id="element-132">
        <div className="flex justify-between items-center mb-2" data-id="element-133">
          <span className="text-sm text-gray-400" data-id="element-134">Storage Used</span>
          <span className="text-sm font-medium" data-id="element-135">3 / 5 scripts</span>
        </div>
        <div className="w-full bg-gray-800 rounded-full h-2.5" data-id="element-136">
          <div className="bg-[#51a7fa] h-2.5 rounded-full" style={{
          width: '60%'
        }} data-id="element-137"></div>
        </div>
      </div>
      <div className="space-y-4 mb-6" data-id="element-138">
        <div className="bg-gray-800 p-3 rounded-lg flex justify-between items-center" data-id="element-139">
          <div data-id="element-140">
            <h3 className="font-medium" data-id="element-141">Welcome Script</h3>
            <p className="text-xs text-gray-400" data-id="element-142">2 KB • Last edited: Today</p>
          </div>
          <button className="text-red-500 hover:text-red-400 text-sm" data-id="element-143">
            Delete
          </button>
        </div>
        <div className="bg-gray-800 p-3 rounded-lg flex justify-between items-center" data-id="element-144">
          <div data-id="element-145">
            <h3 className="font-medium" data-id="element-146">Presentation Introduction</h3>
            <p className="text-xs text-gray-400" data-id="element-147">
              3 KB • Last edited: Yesterday
            </p>
          </div>
          <button className="text-red-500 hover:text-red-400 text-sm" data-id="element-148">
            Delete
          </button>
        </div>
        <div className="bg-gray-800 p-3 rounded-lg flex justify-between items-center" data-id="element-149">
          <div data-id="element-150">
            <h3 className="font-medium" data-id="element-151">Video Script</h3>
            <p className="text-xs text-gray-400" data-id="element-152">
              4 KB • Last edited: 3 days ago
            </p>
          </div>
          <button className="text-red-500 hover:text-red-400 text-sm" data-id="element-153">
            Delete
          </button>
        </div>
      </div>
      <button className="w-full bg-red-900 text-white py-2 rounded-lg" data-id="element-154">
        Delete All Data
      </button>
    </div>;
  const renderMainAccountView = () => <div className="bg-gray-900 p-6 rounded-lg" data-id="element-155">
      <div className="flex flex-col items-center mb-6" data-id="element-156">
        <div className="bg-gray-800 p-4 rounded-full mb-4" data-id="element-157">
          <UserIcon size={48} data-id="element-158" />
        </div>
        <h2 className="text-xl font-semibold" data-id="element-159">user@example.com</h2>
      </div>
      <div className="space-y-4" data-id="element-160">
        <div className="bg-gray-800 p-4 rounded-lg cursor-pointer hover:bg-gray-700" onClick={() => setViewMode('subscription')} data-id="element-161">
          <h3 className="font-semibold mb-1" data-id="element-162">Subscription</h3>
          <p className="text-gray-400" data-id="element-163">Free Plan</p>
        </div>
        <div className="bg-gray-800 p-4 rounded-lg cursor-pointer hover:bg-gray-700" onClick={() => setViewMode('devices')} data-id="element-164">
          <h3 className="font-semibold mb-1" data-id="element-165">Synced Devices</h3>
          <p className="text-gray-400" data-id="element-166">3 devices connected</p>
        </div>
        <div className="bg-gray-800 p-4 rounded-lg cursor-pointer hover:bg-gray-700" onClick={() => setViewMode('storage')} data-id="element-167">
          <h3 className="font-semibold mb-1" data-id="element-168">Cloud Storage</h3>
          <p className="text-gray-400" data-id="element-169">3 scripts saved</p>
        </div>
      </div>
      <button onClick={handleLogout} className="w-full mt-6 bg-red-900 text-white py-3 rounded-lg flex items-center justify-center" data-id="element-170">
        <LogOutIcon size={20} className="mr-2" data-id="element-171" />
        Sign Out
      </button>
    </div>;
  return <div className="flex-1 flex flex-col" data-id="element-172">
      <PageHeader title="Account" data-id="element-173" />
      <div className="flex-1 p-6 flex flex-col items-center justify-center" data-id="element-174">
        <div className="w-full max-w-md" data-id="element-175">
          {isLoggedIn ? <>
              {viewMode === 'main' && renderMainAccountView()}
              {viewMode === 'devices' && renderSyncedDevices()}
              {viewMode === 'subscription' && renderSubscriptionOptions()}
              {viewMode === 'storage' && renderStorageDetails()}
            </> : <>{isRegistering ? renderRegistrationForm() : renderLoginForm()}</>}
        </div>
      </div>
    </div>;
};
export default AccountPage;